import navigation from "@/pages/global/components/nav-bar/nav-bar.vue";
import bottom from "@/pages/global/components/bottom-bar/bottom-bar.vue";

export default {
    name: 'FeedPortlet',
    components: {
        navigation,
        bottom
    },
    props: {
        feedPortlet: Object,
    },
    methods: {
        fetchUserEmail(userId, docId) {
            this.$store.dispatch('feed/fetchUserEmail', {
                'userId': userId,
                'docId': docId
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/feed/components/feed-portlet/feed-portlet.js